/**
 * 模型用例🌹
 */
// 入口文件
export const modelAppCode = `import Pano from './src/Pano/index.tsx';
const App = () => {
  return <Pano />;
};
export default App;
`;
// 模型初始化
export const useInitModel = `import React, { useEffect, useRef, useState } from 'react';
import roamingConfig from './mockData/roamingConfig';
/**
 * npm引入
 * import { Meshviewer, ProgressAPI } from '@ali/tide-wanhuatong-sdk/editor';
 * import SpotTagPlugin from '@ali/tide-wanhuatong-sdk/plugins/spotTag.js';
 * import AiTourPlugin from '@ali/tide-wanhuatong-sdk/plugins/aiTour.js';
 *
 */
/**
 * script资源引入
 * const { Meshviewer, ProgressAPI } = TideWanhuatong;
 * const { AiTourPlugin, SpotTagPlugin } = TideWanhuatongPlugins;
 */
const { Meshviewer, ProgressAPI } = TideWanhuatong;
const { Application } = Meshviewer;
const { AiTourPlugin, SpotTagPlugin } = TideWanhuatongPlugins;
const useInitModel = (props) => {
  const { container, openSTG = false, openAITG = false,multiFloor = false } = props;
  const [app, setApp] = useState(null);
  const appModel = useRef(null);
  const init = async () => {
    const rootPath = multiFloor ? 'https://lyj-public.aliyuncdn.com/pano_test/A.e.retWb91RhFTNo5Si/' : 'https://lyj-public.aliyuncdn.com/pano_test/A.e.wrWWWXh7H0CEQxNi/'
    const configResolver = {
      resolve: async (relativePath) => {
        switch (relativePath) {
          case 'config.json':
            const configModelDataPath =
              rootPath + 'config.json' + '?ver=' + Date.now();
            const configModelData = await axios.get(configModelDataPath);
            return configModelData.data;
          case 'orthomap/orthomap.json':
            const orthsmapDataPath =
              rootPath + 'orthomap/orthomap.json' + '?ver=' + Date.now();
            const orthsMapData = await axios.get(orthsmapDataPath);
            return orthsMapData.data;
          default:
            break;
        }
      },
    };
    const resourcesResolver = {
      resolve: async (relativePath) => {
        const url = rootPath + relativePath + '?ver=' + Date.now();
        return url;
      },
    };
    const _app = new Application(container.current, {
      config: configResolver,
      publicResourceResolver: resourcesResolver,
      privateResourceResolver: resourcesResolver,
      renderOption: {
        preserveDrawingBuffer: true,
      },
    });
    if (openSTG) {
      _app.use(new SpotTagPlugin(), 'SpotTagPlugin', { lineLength: 4.5 });
    }
    if (openAITG) {
      _app.use(new AiTourPlugin(),'AiTourPlugin',roamingConfig);
    }
    ProgressAPI.event.on('AppInitEnd', () => {
      console.log('AppInitEnd');
    });
    ProgressAPI.event.on('ResourceLoadEnd', () => {
      console.log('ResourceLoadEnd');
    });
    appModel.current = _app;
    setApp(_app);
    _app.start().then(() => {});
  };
  useEffect(() => {
    if (appModel.current) return;
    async function feachData() {
      await init();
    }
    feachData();
  }, []);

  return [app];
};

export default useInitModel;
`;

// 配置测试
export const panoModelCode = `import React, { useEffect, useRef } from "react";
import useInitModel from "../useInitModel";
const { Meshviewer, ProgressAPI } = TideWanhuatong;
const containerStyle = {
  height: '420px',
  width: '100%',
  display: 'flex',
  position: 'relative',
}
export default function Pano() {
  const container = useRef(null);
  const [app] = useInitModel({ container });
  useEffect(() => {
    if (!app) return;
    ProgressAPI.event.on('SceneLoadEnd', () => {
      console.log('SceneLoadEnd');
    });
  }, [app]);
  return (
    <div id="meshviewer" ref={container} style={containerStyle}></div>
  );
}`;

//场景跳转测试
export const transitionCode = `import React, { useEffect, useRef } from "react";
import useInitModel from "../useInitModel";
const { Meshviewer, ProgressAPI } = TideWanhuatong;
const containerStyle = {
  height: '420px',
  width: '100%',
  display: 'flex',
  position: 'relative',
}
export default function Transition() {
  const container = useRef(null);
  const [app] = useInitModel({ container });
  useEffect(() => {
    if (!app) return;
    ProgressAPI.event.on('SceneLoadEnd', () => {
      console.log('SceneLoadEnd');
      const transitionAPI = app.getInstance("transitionControlAPI");
      transitionAPI.event.on("toTopView", () => {
        console.log("切换到top视图", 111111111);
      });
      transitionAPI.event.on("toNormalView", () => {
        console.log("切换到normal视图", 222222222);
      });
      transitionAPI.event.on("toSpot", (spot, floor) => {
        console.log("切换到全景图", spot, floor);
      });

      document.getElementById("to3DView").onclick = async function (e) {
        transitionAPI.switchToNormalView();
      };
      document.getElementById("toTopView").onclick = async function (e) {
        transitionAPI.switchToTopView();
      };
      document.getElementById("toPanoramaView").onclick = async function (
        e
      ) {
        transitionAPI.switchToPanoramaView();
      };
    });
  }, [app]);
  return (
    <div>
      <div id="meshviewer" ref={container} style={containerStyle}></div>
      <button id="to3DView">鸟瞰视图</button>
      <button id="toTopView">俯瞰视图</button>
      <button id="toPanoramaView">全景视图</button>
    </div>
  );
}`;

// 热点测试
export const hotSpotCode = `import React, { useEffect, useRef } from "react";
import useInitModel from "../useInitModel";
const { Meshviewer, ProgressAPI } = TideWanhuatong;
const containerStyle = {
  height: '420px',
  width: '100%',
  display: 'flex',
  position: 'relative',
}
export default function HotSpot() {
  const container = useRef(null);
  const [app] = useInitModel({ container });
  useEffect(() => {
    if (!app) return;
    ProgressAPI.event.on('SceneLoadEnd', () => {
      console.log('SceneLoadEnd');
      const elementsAPI = app.getInstance("elementsAPI");
      const annotationConfig = {"hot-7eb8972b-13b9-40c7-ad13-12697890d8e4":{"id":"hot-a2376ca6-18c4-43b4-b522-b798561f9d6b","type":"hot","spotId":"p0","info":{"titleConfig":{"content":"热点标签","fontSize":"12px","color":"#fff","backgroundColor":"#000000B3","opacity":1,"showStrategy":"hover"},"iconConfig":{"url":"https://repos3d.cdn.bcebos.com/v1/penglai/es/4.1/point.svg","width":"40px","height":"40px","opacity":1}},"anchor":{"x":-2.806628942489624,"y":4.7847490310668945,"z":1.0771491527557373},"includeSpots":["p0","p1","p2","p3","p4","p5","p6","p7","p8","p9"],"normal":[]}, "image-7990c237-64e0-4630-8fd8-8fe183ff6a67": {"id":"image-7990c237-64e0-4630-8fd8-8fe183ff6a67","type":"image","info":{"mediaRatio":1,"keyValue":"请输入浮层标签标题","src":"https://virutalbuy-public.oss-cn-hangzhou.aliyuncs.com/xuhui/img/%E6%88%AA%E5%B1%8F2022-04-22%20%E4%B8%8B%E5%8D%882.29.48.png","type":"image","muted":true,"strategy":{"visible":{"view":"ALL_SPOTS","condition":[],"distance":30}},"control":true},"scale":{"x":0.2,"y":0.2},"anchor":{"x":-2.5176703929901123,"y":3.420215368270874,"z":1.208158016204834},"includeSpots":["p0","p1","p10","p11","p12","p13","p14","p15","p16","p2","p3","p4","p5","p6","p7","p8","p9"],"global":true,"spotId":"p0","anywhere":true,"rotation":{"x":0,"y":0,"z":0},"mediaType":"IMAGE","renderType":"gl3d","normal":{"x":-1,"y":0,"z":0}}}
      let curAnnotationId = null;
      elementsAPI.init(annotationConfig);

      elementsAPI.event.on("click", (id) => {
        console.log("标签被点击", id);
        curAnnotationId = id;
        const element = elementsAPI.getElementById(id);
        console.log("click element", element);
        element.highlight([255, 0, 0]);
        element.lookAt();
        console.log("element.type", element.type);
        setTimeout(() => {
          element.unhighlight();
        }, 1000);
      });
      elementsAPI.event.on("annotationAdd", async (el) => {
        console.log("标签添加成功", JSON.stringify(el));
        curAnnotationId = el.id;
      });
      elementsAPI.event.on("annotation-no-intersection", () => {
        console.log("打标没找到位置～～～～～～～～");
      });
      elementsAPI.event.on("moving", (el) => {
        // console.log('标签移动', el);
      });
      elementsAPI.event.on("moveStart", (el) => {
        // const element = elementsAPI.getElementById(el.id)
        // console.log('标签移动开始', el);
        // element.highlight([255, 0, 0]);
      });
      elementsAPI.event.on("moveEnd", (el) => {
        // const element = elementsAPI.getElementById(el.id)
        // console.log('标签移动结束', el);
        // element.unhighlight()
      });
      document.getElementById("startHotAnnotating").onclick = async function (
        e
      ) {
        elementsAPI.startAnnotating("hot");
      };
      document.getElementById("deleteAnnotation").onclick = async function (e) {
        elementsAPI.removeAnnotationById(curAnnotationId);
      };
      document.getElementById("hiddenAnnotation").onclick = async function (e) {
        elementsAPI.hiddenAllElement();
      };
      document.getElementById("showAnnotation").onclick = async function (e) {
        elementsAPI.showAllElement();
      };
      document.getElementById('startFloatAnnotating').onclick = function (e) {
        elementsAPI.startAnnotating('image',{ control: true });
      };
      document.getElementById('startLineAnnotating').onclick = function (e) {
        elementsAPI.startAnnotating('line');
      };
      document.getElementById('startAudioAnnotating').onclick = function (e) {
          elementsAPI.startAnnotating('audio');
      };
    });
  }, [app]);
  return (
    <>
      <div id="meshviewer" ref={container} style={containerStyle}></div>
      <button id="startHotAnnotating">开始热点打标</button>
      <button id="startFloatAnnotating">开始浮层打标</button>
      <button id="startLineAnnotating">开始线标打标</button>
      <button id="startAudioAnnotating">开始语音打标</button>
      <button id="deleteAnnotation">删除当前标签</button>
      <button id="hiddenAnnotation">隐藏标签</button>
      <button id="showAnnotation">显示标签</button>
    </>
  );
}`;

// 场景标签
export const spotTagCode = `import React, { useEffect, useRef } from 'react';
import useInitModel from '../useInitModel';
const { Meshviewer, ProgressAPI } = TideWanhuatong;
const containerStyle = {
  height: '420px',
  width: '100%',
  display: 'flex',
  position: 'relative',
}
export default function SpotTag() {
  const container = useRef(null);
  const [app] = useInitModel({ container, openSTG: true });
  useEffect(() => {
    if (!app) return;
    ProgressAPI.event.on('SceneLoadEnd',() => {
      console.log('SceneLoadEnd');
      const transitionAPI = app.getInstance("transitionControlAPI");
      transitionAPI.switchToNormalView();
      const spotTagPlugin = app.getPlugin('SpotTagPlugin');
      document.getElementById('hideTag').onclick = () => {
        spotTagPlugin.hideTagBySpotId('p5', true);
      }
      document.getElementById('showTag').onclick = () => {
        spotTagPlugin.showTagBySpotId('p5', true);
      }
      document.getElementById('showAllTag').onclick = () => {
        spotTagPlugin.showAllTags();
      }
      document.getElementById('hideAllTag').onclick = () => {
        spotTagPlugin.hideAllTags();
      }
      document.getElementById('visibleByConfig').onclick = () => {
        spotTagPlugin.showAllVisibleTags();
      }
      document.getElementById('setTitle').onclick = () => {
        spotTagPlugin.setTagTitle('p6', 232334434334);
      }
      document.getElementById('heighLight').onclick = () => {
        spotTagPlugin.highLight('p7');
      }
      document.getElementById('unhighLight').onclick = () => {
        spotTagPlugin.unhighLight('p7');
      }
      //...
    });
  }, [app]);
  return (
    <div>
      <div id="meshviewer" ref={container} style={containerStyle}></div>
      <button id="hideTag">隐藏标签</button>
      <button id="showTag">显示标签</button>
      <button id="showAllTag">显示所有标签</button>
      <button id="hideAllTag">隐藏所有标签</button>
      <button id="setTitle">设置标签的标题</button>
      <button id="visibleByConfig">根据配置的visible显示标签</button>
      <button id="heighLight">高亮标签</button>
      <button id="unhighLight">取消标签高亮</button>
    </div>
  );
}
`;

// 智能导览
export const aiTourCode = `import React, { useEffect, useRef } from 'react';
import useInitModel from '../useInitModel';
const { Meshviewer, ProgressAPI } = TideWanhuatong;
const containerStyle = {
  height: '420px',
  width: '100%',
  display: 'flex',
  position: 'relative',
}
export default function AiTour() {
  const container = useRef(null);
  const [app] = useInitModel({ container, openAITG: true });
  useEffect(() => {
    if (!app) return;
    ProgressAPI.event.on('SceneLoadEnd',() => {
      console.log('SceneLoadEnd');
      const aiTour = app.getPlugin('AiTourPlugin');
      document.getElementById('startGudie').onclick = () => {
        aiTour.start();
      }
      document.getElementById('pauseGudie').onclick = () => {
        aiTour.pause();
      }
      document.getElementById('resumeGudie').onclick = () => {
        aiTour.resume();
      }
      document.getElementById('switchToGroupByIndex').onclick = () => {
        aiTour.switchToGroupByIndex(2);
      }
    });
  }, [app]);
  return (
    <div>
      <div id="meshviewer" ref={container} style={containerStyle}></div>
      <button id="startGudie">开启导览</button>
      <button id="pauseGudie">暂停导览</button>
      <button id="resumeGudie">恢复导览</button>
      <button id="switchToGroupByIndex">根据索引切换导览路线上的点位</button>
    </div>
  );
}
`;

// 多楼层
export const multiFloorCode = `import React, { useEffect, useRef } from 'react';
import useInitModel from '../useInitModel';
const { Meshviewer, ProgressAPI } = TideWanhuatong;
const containerStyle = {
  height: '420px',
  width: '100%',
  display: 'flex',
  position: 'relative',
}
export default function MutilFloor() {
  const container = useRef(null);
  const [app] = useInitModel({ container, multiFloor: true });

  useEffect(() => {
    if (!app) return;
    ProgressAPI.event.on('SceneLoadEnd',() => {
      console.log('SceneLoadEnd');
      const transitionAPI = app.getInstance('transitionControlAPI'); // 从app上获取api实例
      transitionAPI.switchToNormalView();
      document.getElementById('selectFloor').onclick = () => {
        transitionAPI.selectBuildingFloor('floor_1'); // 选中指定楼层，floorId: "total" | 指定楼层key
      };
      document.getElementById('switchToNoraml').onclick = () => {
        transitionAPI.switchToNormalView();
      };
      document.getElementById('switchToFloor').onclick = () => {
        transitionAPI.switchToFloor('floor_1'); // 选中指定楼层，floorId: "total" | 指定楼层key
      };
    });
  }, [app]);
  return (
    <div>
      <div id="meshviewer" ref={container} style={containerStyle}></div>
      <button id="selectFloor">选中指定楼层</button>
      <button id="switchToFloor">跳转到全景图中指定楼层</button>
      <button id="switchToNoraml">切换至3d视图</button>
    </div>
  );
}
`;
// 相机功能测试
export const cameraCode = `import React, { useEffect, useRef } from 'react';
import useInitModel from '../useInitModel';
const { Meshviewer, ProgressAPI } = TideWanhuatong;
const containerStyle = {
  height: '420px',
  width: '100%',
  display: 'flex',
  position: 'relative',
}
export default function Camera() {
  const container = useRef(null);
  const [app] = useInitModel({ container });
  const controlEnable = useRef(true);
  useEffect(() => {
    if (!app) return;
    ProgressAPI.event.on('SceneLoadEnd',() => {
      const cameraAPI = app.getInstance("cameraAPI");
      cameraAPI.cameraParamsChange.on('theta_phi',(params) => {
        console.log('相机theta、phi变化', params)
      })
      cameraAPI.cameraParamsChange.on('fov',(params) => {
        console.log('fov变化', params)
      })
      document.getElementById("getCameraParams").onclick = function (e) {
        console.log(cameraAPI.getCameraParams());
      };
      document.getElementById("setCameraThetaPhi").onclick = function (e) {
        cameraAPI.setCameraThetaPhi(-2.995985904871005, -0.931161845453807);
      };
      document.getElementById("setCameraFov").onclick = function (e) {
        cameraAPI.setCameraFov(30);
      };
      document.getElementById("setCameraControlEnable").onclick = function (e) {
        cameraAPI.setCameraControlEnable(!controlEnable.current);
        controlEnable.current = !controlEnable.current;
      };
    })
  }, [app]);
  return (
    <div>
      <div id="meshviewer" ref={container} style={containerStyle}></div>
      <button id="getCameraParams">获取相机的当前参数</button>
      <button id="setCameraThetaPhi">设置相机的theta phi</button>
      <button id="setCameraFov">切换相机fov</button>
      <button id="setCameraControlEnable">设置相机是否可以操作</button>
    </div>
  );
}
`;

// 地面导航点
export const spotCode = `import React, { useEffect, useRef } from 'react';
import useInitModel from '../useInitModel';
const { Meshviewer, ProgressAPI } = TideWanhuatong;
const containerStyle = {
  height: '420px',
  width: '100%',
  display: 'flex',
  position: 'relative',
}
export default function Spot() {
  const container = useRef(null);
  const [app] = useInitModel({ container });
  useEffect(() => {
    if (!app) return;
    ProgressAPI.event.on('SceneLoadEnd', () => {
      const hotSpotAPI = app.getInstance("hotSpotAPI");
      hotSpotAPI.event.on("click", (id)=>{
        console.log(id)
      });
      document.getElementById("getCurrentSpotId").onclick = function (e) {
        console.log(hotSpotAPI.getCurrentSpotId());
      };
      document.getElementById("getHotSpots").onclick = function (e) {
        console.log(hotSpotAPI.getHotSpots());
      };
      document.getElementById("hideAllSpots").onclick = function (e) {
        hotSpotAPI.hideAllSpots()
      };
      document.getElementById("showAllSpots").onclick = function (e) {
        hotSpotAPI.showAllSpots()
      };
    })
  }, [app]);
  return (
    <div>
      <div id="meshviewer" ref={container} style={containerStyle}></div>
      <button id="getCurrentSpotId">获取当前spot名称</button>
      <button id="getHotSpots">获取场景中所有spot点</button>
      <button id="hideAllSpots">隐藏所有点位</button>
      <button id="showAllSpots">显示所有点位</button>
    </div>
  );
}
`;

// 走路机器人
export const personGuideCode = `import React, { useEffect, useRef } from 'react';
import useInitModel from '../useInitModel';
const { Meshviewer, ProgressAPI } = TideWanhuatong;
const containerStyle = {
  height: '420px',
  width: '100%',
  display: 'flex',
  position: 'relative',
}
export default function PersonGuide() {
  const container = useRef(null);
  const [app] = useInitModel({ container });
  useEffect(() => {
    if (!app) return;
    ProgressAPI.event.on('SceneLoadEnd', async () => {
      await app.loadHdr()
      const personGuiderAPI = app.getInstance("personGuiderAPI");
      personGuiderAPI.init('v2', 'v2', {});
      document.getElementById("resume").onclick = function (e) {
        personGuiderAPI.resume();
      };
      document.getElementById("pause").onclick = function (e) {
        personGuiderAPI.pause();
      };
    })
  }, [app]);
  return (
    <div>
      <div id="meshviewer" ref={container} style={containerStyle}></div>
      <button id="pause">暂停带看</button>
      <button id="resume">恢复带看</button>
    </div>
  );
}`;

// 飞行导购
export const flyGuideCode = `import React, { useEffect, useRef } from 'react';
import useInitModel from '../useInitModel';
const { Meshviewer, ProgressAPI } = TideWanhuatong;
const containerStyle = {
  height: '420px',
  width: '100%',
  display: 'flex',
  position: 'relative',
}
export default function PersonGuide() {
  const container = useRef(null);
  const [app] = useInitModel({ container });
  const visible = useRef(true);
  useEffect(() => {
    if (!app) return;
    ProgressAPI.event.on('SceneLoadEnd', async () => {
      await app.loadHdr()
      const flyGuiderAPI = app.getInstance("flyGuiderAPI");
      flyGuiderAPI.init('built-in', 'built-in', undefined);
      document.getElementById("switchEmotion").onclick = function (e) {
        flyGuiderAPI.switchEmotion('speak')
      };
      document.getElementById("setGuiderVisible").onclick = function (e) {
        flyGuiderAPI.setGuiderVisible(visible.current);
        visible.current = !visible.current
      };
    })
  }, [app]);
  return (
    <div>
      <div id="meshviewer" ref={container} style={containerStyle}></div>
      <button id="switchEmotion">切换表情</button>
      <button id="setGuiderVisible">设置飞行器的可见状态</button>
    </div>
  );
}`;

/**
 * 全景图示例🌹
 */
export const panoImageApp = `import PanoImg from './src/Pano/index.tsx';
 const App = () => {
   return <PanoImg />;
 };
 export default App;
 `;
// 初始化全景图
export const initPanoIamgeCode = `import React, { useEffect, useRef, useState } from "react";
const { Meshviewer } = TideWanhuatong;
const { Application, ProgressReporter } = Meshviewer;

const useInitPanoImage = (props) => {
  const { container } = props;
  const [app, setApp] = useState(null);
  const appModel = useRef(null);
  const init = () => {
    const _app = new Application(container.current, {
      sceneType: "panoImage",
      ossParams: {
        oss_path: "oss://lyj-public/pano/A.e.ewQtf6djzPdq6x06",
        endpoint: "oss-cn-hangzhou.aliyuncs.com",
      },
    });
    appModel.current = _app;
    setApp(_app);
    _app.start().then(() => {});
    ProgressReporter.onLoaded.subscribe(() => {
      console.log('onLoaded');
    })
  };
  useEffect(() => {
    if (appModel.current) return;
    init();
  }, []);
  return [app];
};

export default useInitPanoImage
`;

// 全景图
export const panoImageCode = `import React, { useEffect, useRef } from "react";
import useInitPanoImage from "../useInitPanoImage.tsx";
const { Meshviewer } = TideWanhuatong;
const containerStyle = {
  height: '420px',
  width: '100%',
  display: 'flex',
  position: 'relative',
}
const PanoImg = () => {
  const container = useRef(null);
  const [app] = useInitPanoImage({ container });
  const enbaleRotate = useRef(true);
  useEffect(() => {
    if (!app) return;
    const elementsAPI = app.getInstance('elementsAPI');
    const imageSceneAPI = app.getInstance('imageSceneAPI');
    const annotationConfig = {"hot-7eb8972b-13b9-40c7-ad13-12697890d8e4":{"id":"hot-a2376ca6-18c4-43b4-b522-b798561f9d6b","type":"hot","spotId":"p0","info":{"titleConfig":{"content":"热点标签","fontSize":"12px","color":"#fff","backgroundColor":"#000000B3","opacity":1,"showStrategy":"hover"},"iconConfig":{"url":"https://repos3d.cdn.bcebos.com/v1/penglai/es/4.1/point.svg","width":"40px","height":"40px","opacity":1}},"anchor":{"x":-2.806628942489624,"y":4.7847490310668945,"z":1.0771491527557373},"includeSpots":["p0","p1","p2","p3","p4","p5","p6","p7","p8","p9"],"normal":[]}, "image-7990c237-64e0-4630-8fd8-8fe183ff6a67": {"id":"image-7990c237-64e0-4630-8fd8-8fe183ff6a67","type":"image","info":{"mediaRatio":1,"keyValue":"请输入浮层标签标题","src":"https://virutalbuy-public.oss-cn-hangzhou.aliyuncs.com/xuhui/img/%E6%88%AA%E5%B1%8F2022-04-22%20%E4%B8%8B%E5%8D%882.29.48.png","type":"image","muted":true,"strategy":{"visible":{"view":"ALL_SPOTS","condition":[],"distance":30}},"control":true},"scale":{"x":0.2,"y":0.2},"anchor":{"x":-2.5176703929901123,"y":3.420215368270874,"z":1.208158016204834},"includeSpots":["p0","p1","p10","p11","p12","p13","p14","p15","p16","p2","p3","p4","p5","p6","p7","p8","p9"],"global":true,"spotId":"p0","anywhere":true,"rotation":{"x":0,"y":0,"z":0},"mediaType":"IMAGE","renderType":"gl3d","normal":{"x":-1,"y":0,"z":0}}}
    elementsAPI.init(annotationConfig);
    document.getElementById('startHotAnnotating').onclick = async function (e) {
      elementsAPI.startAnnotating('hot');
    };
    document.getElementById('startLineAnnotating').onclick = function (e) {
      elementsAPI.startAnnotating('line');
    };
    document.getElementById('setCameraRotateRate').onclick = function (e) {
      imageSceneAPI.setCameraRotateRate(10);
    };
    document.getElementById('enableCameraAutoRotate').onclick = function (e) {
      imageSceneAPI.enableCameraAutoRotate(!enbaleRotate.current);
      enbaleRotate.current = !enbaleRotate.current;
    };
  }, [app]);
  return <div>
    <div id="pano-container" ref={container} style={containerStyle}></div>
    <button id="startHotAnnotating">开始热点打标</button>
    <button id="startLineAnnotating">开始线标打标</button>
    <button id="setCameraRotateRate">设置相机自动旋转速率</button>
    <button id="enableCameraAutoRotate">设置相机自动旋转</button>
  </div>;
};

export default PanoImg;`;

/**
 * 全景视频示例
 */
export const panoVideoApp = `import PanoVideo from './src/Pano/index.tsx';
const App = () => {
  return <PanoVideo />;
};
export default App;
`;

// 初始化全视频
export const initPanoVideoCode = `import React, { useEffect, useRef, useState } from "react";
const { Meshviewer } = TideWanhuatong;
const { Application, ProgressReporter } = Meshviewer;

const useInitPanoVideo = (props) => {
  const { container } = props;
  const [app, setApp] = useState(null);
  const appModel = useRef(null);
  const init = () => {
    const _app = new Application(container.current, {
      sceneType: 'panoVideo',
      videoUrl: "https://virutalbuy-public.oss-cn-hangzhou.aliyuncs.com/xuhui/video/qjsp.mp4",
      isLoop: false,
      rotateOption: {
        // autoRotate: true
      }
    });
    appModel.current = _app;
    setApp(_app);
    _app.start().then(() => {});
    ProgressReporter.onLoaded.subscribe(() => {
      console.log('onLoaded');
    })
  };
  useEffect(() => {
    if (appModel.current) return;
    init();
  }, []);
  return [app];
};

export default useInitPanoVideo
`;

// 全景视频
export const panoVideoCode = `import React, { useEffect, useRef } from "react";
import useInitPanoVideo from "../useInitPanoVideo.tsx";
const { Meshviewer } = TideWanhuatong;
const containerStyle = {
  height: '420px',
  width: '100%',
  display: 'flex',
  position: 'relative',
}
const PanoImg = () => {
  const container = useRef(null);
  const [app] = useInitPanoVideo({ container });
  const isMuted = useRef(false)
  useEffect(() => {
    if (!app) return;
    const videoSceneAPI = app.getInstance('videoSceneAPI');
    document.getElementById('play').onclick = function (e) {
      videoSceneAPI.play();
    };
    document.getElementById('pause').onclick = function (e) {
      videoSceneAPI.pause();
    };
    document.getElementById('reset').onclick = function (e) {
      videoSceneAPI.reset();
    };
    document.getElementById('setVideoMuted').onclick = function (e) {
      videoSceneAPI.setVideoMuted(!isMuted.current);
      isMuted.current = !isMuted.current
    };
    document.getElementById('getTotalTime').onclick = function (e) {
      console.log('视频总时长',videoSceneAPI.getTotalTime())
    };
    document.getElementById('getCurrentTime').onclick = function (e) {
      console.log('获取视频当前播放时间',videoSceneAPI.getCurrentTime())
    };
    document.getElementById('jumpTo').onclick = function (e) {
      videoSceneAPI.jumpTo(30)
    };
    document.getElementById('setVideoUrl').onclick = function (e) {
      videoSceneAPI.setVideoUrl('https://lyj-public.aliyuncdn.com/pano_src/100070-1358108/video/video.mp4')
    };
    document.getElementById('setPlaybackRate').onclick = function (e) {
      videoSceneAPI.setPlaybackRate(3)
    };
  }, [app]);
  return <div>
    <div id="video-container" ref={container} style={containerStyle}></div>
    <button id="play">播放视频</button>
    <button id="pause">暂停视频</button>
    <button id="reset">重制视频</button>
    <button id="setVideoMuted">设置视频是否禁音</button>
    <button id="getTotalTime">获取视频总时长</button>
    <button id="getCurrentTime">获取视频当前播放时间</button>
    <button id="jumpTo">跳转到视频指定时间</button>
    <button id="setVideoUrl">设置播放链接</button>
    <button id="setPlaybackRate">设置播放速度</button>
  </div>;
};

export default PanoImg;`;

//---------------------------------------------
export const theme = {
  colors: {
    surface1: "#060d16",
    surface2: "#2b2e30",
    surface3: "#2b2e31",
    clickable: "#a7a7a7",
    base: "#a7aeb6",
    disabled: "#444344",
    hover: "#FCFCFA",
    accent: "#f8f6f5",
    error: "#ffcdca",
    errorSurface: "#c24038",
  },
  syntax: {
    plain: "rgb(252, 252, 250)",
    comment: {
      color: "#757575",
      fontStyle: "italic",
    },
    keyword: "#ff88a1",
    tag: "#cac4ff",
    punctuation: "rgb(147, 146, 147)",
    definition: "#5dff56",
    property: "#09e7e7",
    static: "rgb(171, 157, 242)",
    string: "#fca819",
  },
  font: {
    body: 'Karla, Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
    mono: '"Hack Dotted Zero", "Fira Mono", "DejaVu Sans Mono", Menlo, Consolas, "Liberation Mono", Monaco, "Lucida Console", monospace',
    size: "14px",
    lineHeight: "20px",
  },
};

export const options = {
  // /**
  //  * List of files that will be visible for the user interacts with.
  //  * It defaults to the main file from a given template.
  //  */
  //  visibleFiles?: string[];
  //  /**
  //   * Use this to set a file as active by default in the editor component.
  //   * It defaults to the main file from a given template.
  //   */
  //  activeFile?: string;
  //  editorWidthPercentage?: number;
  //  editorHeight?: React.CSSProperties["height"];
  //  classes?: Record<string, string>;
  //  showNavigator?: boolean;
  //  showLineNumbers?: boolean;
  //  showInlineErrors?: boolean;
  //  showRefreshButton?: boolean;
  //  showTabs?: boolean;
  //  showConsoleButton?: boolean;
  //  showConsole?: boolean;
  //  closableTabs?: boolean;
  //  wrapContent?: boolean;
  //  codeEditor?: SandpackCodeOptions;
  //  /**
  //   * This disables editing of content by the user in all files.
  //   */
  //  readOnly?: boolean;
  //  /**
  //   * Controls the visibility of Read-only label, which will only
  //   * appears when `readOnly` is `true`
  //   */
  //  showReadOnly?: boolean;
  //  /**
  //   * This provides a way to control how some components are going to
  //   * be initialized on the page. The CodeEditor and the Preview components
  //   * are quite expensive and might overload the memory usage, so this gives
  //   * a certain control of when to initialize them.
  //   */
  //  initMode?: SandpackInitMode;
  //  initModeObserverOptions?: IntersectionObserverInit;
  //  autorun?: boolean;
  //  recompileMode?: "immediate" | "delayed";
  //  recompileDelay?: number;
  //  /**
  //   * By default, Sandpack generates a random value to use as an id.
  //   * Use this to override this value if you need predictable values.
  //   */
  //  id?: string;
  //  logLevel?: SandpackLogLevel;
  //  bundlerURL?: string;
  //  startRoute?: string;
  //  skipEval?: boolean;
  //  fileResolver?: FileResolver;
  //  externalResources?: string[];
  showConsoleButton: true,
  showTabs: true, // 显示选项卡
  recompileMode: "delayed",
  recompileDelay: 2000,
  showConsole: true,
  editorHeight: 600,
  showLineNumbers: true,
  closableTabs: true,
  editorWidthPercentage: 50,
  showInlineErrors: true,
  externalResources: [
    "https://g.alicdn.com/sail-fe/alibaba-lyj-js-player-umd/1.1.4/editor.js",
    "https://cdn.jsdelivr.net/npm/axios/dist/axios.min.js",
    "https://gw.alipayobjects.com/os/lib/react/17.0.2/umd/react.development.js",
    "https://gw.alipayobjects.com/os/lib/react-dom/17.0.2/umd/react-dom.development.js",
    "https://g.alicdn.com/sail-fe/alibaba-lyj-js-player-umd/1.1.0/plugin.js",
  ],
};

export const panoCssCode = `
#pano-container{
  height: 420px;
  width: 100%;
  display: flex;
  position: relative;
}
`;
export const videoCssCode = `
#video-container{
  height: 420px;
  width: 100%;
  display: flex;
  position: relative;
}
`;

export const McokHtml = `<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>Document</title>
    <script src='App.js'></script>
  </head>
  <body>
    <div id="root"></div>
  </body>
</html>
`;
export const mockTsCfg = `{"include": ["./src/**/*"],
"compilerOptions": {
  "strict": true,
  "esModuleInterop": true,
  "lib": [
    "dom",
    "es2015"
  ],
  "jsx": "react"
}
}`;
